export const capitalize = (str = '') =>
    str ? str[0].toUpperCase() + str.slice(1) : ''

export const isValidEmail = (email = '') => {
    const value = String(email).trim()
    if (!value) return false
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
}

export const formatPriceNl = (value) => {
    if (value === null || value === undefined) return '--'
    const numeric = Number(value)
    if (Number.isNaN(numeric)) return String(value)
    return numeric.toFixed(2).replace('.', ',')
}

export const customerCanCreateReservation = (customer) => {
    if (!customer) return false

    // A customer without a check result is still waiting for approval.
    return customer?.check_result?.accepted === true
}
